/**
 *     Import
 *     - Libraries
 */
import glamorous from 'glamorous'
import { Link } from 'react-router-dom'

/**
 *     Import
 *     - CSS Helpers
 */
import * as colours from '../../../../../styles/colours'
import * as fonts from '../../../../../styles/typography'
import { easing } from '../../../../../styles/animation'

export const StyledLinkButton = glamorous(Link)({
    display: 'flex',
    width: '100%',
    height: 60,
    border: 'none',
    borderTop: `1px solid ${colours.mainStroke}`,
    outline: 'none',
    backgroundColor: colours.brandBl,
    color: colours.white,
    fontFamily: fonts.fontMedium,
    fontSize: 20,
    fontWeight: 500,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    textDecoration: 'none',
    transition: `background-color 250ms ${easing.easeOut}, color 250ms ${easing.easeOut}`,
})



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/ForgotForm/components/LinkButton/LinkButton.glamorous.tsx